export const ROOT_URL = process.env.REACT_APP_API_ENDPOINT || `${window.location.origin}/`;


export const VERSION_TAG = process.env.REACT_APP_VERSION || "dev";

export const IS_DEMO = !!process.env.REACT_APP_IS_DEMO;
